// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React, { CSSProperties } from 'react'
import { List } from 'antd'
import { Dispatch, RootState } from 'store'
import { connect } from 'react-redux'
import { DeviceListItem } from './DeviceListItem'
import items from '../../mock/data/dongle_devices.json'
import { MultipleSelectionModel } from 'utils/multiple-selection-model'

function mapState(state: RootState) {
  return {
    dongleState: state.dongleDevices
  }
}

function mapDispatch(dispatch: Dispatch) {
  return {
    dongleAction: dispatch.dongleDevices
  }
}

export type IDeviceFinderProps = ReturnType<typeof mapState> &
  ReturnType<typeof mapDispatch> & {
  items: any[]
  style: CSSProperties
  handleDetailOpen: () => void
}

class DeviceFinder extends React.Component<IDeviceFinderProps> {
  state = {}

  private listContainer = React.createRef<HTMLDivElement>()

  componentDidMount() {

  }

  componentDidUpdate(prevProps) {
  }

  componentWillUnmount() {

  }

  private renderContent = (): JSX.Element => {
    return (
      <div ref={this.listContainer} className='device-finder-list'>
        <List
          split
          dataSource={items}
          renderItem={this.renderItem}
          style={{ overflow: 'auto', height: '100%' }}
        />
      </div>
    )
  }

  private renderItem = (item, index): JSX.Element => {
    return (
      <DeviceListItem
        item={item}
        handleClick={this.handleDeviceClick}
      />
    )
  }

  handleDeviceClick = async (deviceID) => {
    const { dongleAction, handleDetailOpen } = this.props
    await dongleAction.fetchDongleReports({ deviceID: deviceID, page: 1, pageSize: 10000 })
    await dongleAction.fetchDongleHardware({ deviceID: deviceID, page: 1, pageSize: 10000 })
    handleDetailOpen()
  }

  render() {
    //const { style = {} } = this.props
    const Content = this.renderContent()
    return (
      <div>
        {Content}
      </div>
    )
  }
}

export default connect(mapState, mapDispatch)(DeviceFinder)
